import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CatalogPage from './pages/CatalogPage';
import CartPage from './pages/CartPage';
import OrderPage from './pages/OrderPage';
import OrdersPage from './pages/OrdersPage';
import Navbar from './components/Navbar';
import './App.css';

// Импортируем setOnUnauthorized
import { setOnUnauthorized } from './api';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(
        !!localStorage.getItem('token')
    );

    const handleLoginSuccess = (token) => {
        localStorage.setItem('token', token);
        setIsAuthenticated(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
    };

    // При первом рендере «регистрируем» обработчик 401
    useEffect(() => {
        setOnUnauthorized(() => {
            // При 401 делаем логаут и переходим на /login
            handleLogout();
            window.location.href = '/login';
        });
    }, []);

    return (
        <Router>
            <Navbar isAuthenticated={isAuthenticated} onLogout={handleLogout} />

            <main className="app-shell">
                <Routes>
                    <Route
                        path="/login"
                        element={<LoginPage onLoginSuccess={handleLoginSuccess} />}
                    />
                    <Route
                        path="/register"
                        element={<RegisterPage />}
                    />
                    <Route
                        path="/"
                        element={
                            isAuthenticated ? <CatalogPage /> : <Navigate to="/login" />
                        }
                    />
                    <Route
                        path="/cart"
                        element={
                            isAuthenticated ? <CartPage /> : <Navigate to="/login" />
                        }
                    />
                    <Route
                        path="/order/:orderId"
                        element={
                            isAuthenticated ? <OrderPage /> : <Navigate to="/login" />
                        }
                    />
                    <Route
                        path="/orders"
                        element={
                            isAuthenticated ? <OrdersPage /> : <Navigate to="/login" />
                        }
                    />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </main>
        </Router>
    );
}

export default App;
